var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.354 4.354a.5.5 0 000-.708L15.172.464a.5.5 0 10-.708.708L17.293 4l-2.829 2.828a.5.5 0 10.708.708l3.182-3.182zM0 4.5h18v-1H0v1z",
    fill: "currentColor"
  })));
}
export default SvgInputArrow;